import React from 'react';
import clsx from 'clsx';
// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Disclosure} from '@headlessui/react';

//components
import SanityRichText from './SanityRichTextClient.client';

//types
import {Block} from '@sanity/types';

interface Props {
  readMoreLabel: string | undefined | null;
  shipping: Block[] | undefined | null;
  shippingLabel: string | undefined | null;
  description: string | Block[] | undefined | null;
  storefrontDescription: string | undefined | null;
  descriptionLabel: string | undefined | null;
}

export default function ProductAdditionalInfo({
  readMoreLabel,
  shipping,
  shippingLabel,
  description,
  storefrontDescription,
  descriptionLabel,
}: Props) {
  const [activeTab, setActiveTab] = React.useState('description');
  return (
    <div className="product-details">
      <div className="border">
        <div className="pb-[25px] md:px-[25px]">
          <div className="mb-6 grid grid-cols-2 md:mb-[40px] md:grid-cols-12 md:gap-x-[18px]">
            <button
              onClick={() => setActiveTab(() => 'description')}
              className={clsx([
                'md:cols-span-6 min-h-[60px] border border-t-0 border-black  md:col-span-5',
                activeTab === 'description'
                  ? 'bg-hk-orange'
                  : 'bg-hk-deep-gray',
              ])}
            >
              {descriptionLabel ?? 'Description'}
            </button>
            <button
              onClick={() => setActiveTab(() => 'shipping')}
              className={clsx([
                'md:cols-span-6 min-h-[60px] border border-t-0 border-black  md:col-span-5',
                activeTab === 'shipping' ? 'bg-hk-orange' : 'bg-hk-deep-gray',
              ])}
            >
              {shippingLabel ?? 'Shipping & Return'}
            </button>
          </div>
          <div className="px-[25px] text-sm md:min-h-[200px] md:px-0 md:text-md">
            <Reveal
              activeTab={activeTab}
              type="description"
              storefrontDescription={storefrontDescription}
              content={
                <>
                  {description ? (
                    <SanityRichText richtext={description} />
                  ) : null}
                </>
              }
              readMoreLabel={readMoreLabel}
            />
            <Reveal
              activeTab={activeTab}
              storefrontDescription={null}
              type="shipping"
              content={
                <>{shipping && <SanityRichText richtext={shipping} />}</>
              }
              readMoreLabel={readMoreLabel}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

interface RevealProps {
  activeTab: string;
  content: React.ReactNode;
  type: 'description' | 'shipping';
  readMoreLabel: string | undefined | null;
  storefrontDescription: string | undefined | null;
}

function Reveal({
  activeTab,
  content,
  type,
  readMoreLabel,
  storefrontDescription,
}: RevealProps) {
  const [isRevealed, setIsRevealed] = React.useState(false);
  return (
    <div
      className={clsx([
        'font-light leading-relaxed',
        activeTab === type ? 'block' : 'hidden',
      ])}
    >
      {storefrontDescription ? (
        <div
          className={clsx('product-info-box', isRevealed && 'h-auto')}
          dangerouslySetInnerHTML={{__html: storefrontDescription}}
        />
      ) : (
        <div className={clsx('product-info-box', isRevealed && 'h-auto')}>
          {content}
        </div>
      )}
      <button
        className={clsx(['text-hk-orange', isRevealed && 'hidden'])}
        onClick={() => setIsRevealed(() => true)}
      >
        {readMoreLabel ?? 'read more'}
      </button>
    </div>
  );
}
